import type { RegistryCurrentListDataSource } from '@app/pages/RegistryPageInner/types'
import type { SwitchColumn } from './types'

export const isSwitchColumns = (columnKey: keyof RegistryCurrentListDataSource): columnKey is SwitchColumn => {
  const switchColumnMap: Partial<Record<keyof RegistryCurrentListDataSource, boolean>> = {
    isEPP: true,
    isRecalculation: true,
    isShortKvi: true,
    isTop1: true,
    isInfo: true
  }

  return !!switchColumnMap[columnKey]
}
